import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CurrProfileContext } from './App/App.tsx';
import { supabase } from './supabaseClient.js';

import { AppBar, Box, Toolbar, IconButton, Typography, 
  Menu, Container, Button, Tooltip, MenuItem, Avatar} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

// website header for both mobile and desktop views
// main page navigation + profile

function ResponsiveAppBar() {
  const nav = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { profile, setProfile } = useContext(CurrProfileContext);

  const handleOpenNavMenu = (event) => { setAnchorElNav(event.currentTarget); };
  const handleOpenUserMenu = (event) => { setAnchorElUser(event.currentTarget); };
  const handleCloseNavMenu = () => { setAnchorElNav(null); };
  const handleCloseUserMenu = () => { setAnchorElUser(null); };

  const logout = () => {
    supabase.auth.signOut().then((res) => {
      if(res.error) {
        console.error("Failed to sign out: " + res.error.message);
      } else {
        console.log("Logged out.");

        // any cached data from previous session should be destroyed
        setProfile(null);
        nav("/");
      }
    });
  }

  return (
    <AppBar sx={{ backgroundColor: '#180a38', margin: "0px", position: 'sticky' }} >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* SMALL SCREEN WIDTH MENU (mobile view) */}
          <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              <MenuItem  onClick={() => {
                setAnchorElNav(false);
                nav("/");
              }} sx={{ color: 'black', }}>Event Map</MenuItem>
              <MenuItem  onClick={() => {
                setAnchorElNav(false);
                nav("/search");
              }} sx={{ color: 'black', }}>Search</MenuItem>
              <MenuItem  onClick={() => {
                setAnchorElNav(false);
                nav("/feed");
              }} sx={{ color: 'black', }}>Event Feed</MenuItem>
              <MenuItem  onClick={() => {
                setAnchorElNav(false);
                nav("/create_event");
              }} sx={{ color: 'black', }}>Create Event</MenuItem>
            </Menu>
          </Box>
          <Typography
            noWrap
            component="div"
            sx={{ml: 4, flexGrow: 1, alignItems: 'center', gap: '20px',
              display: {xs: "flex", md: "none"}}}
          >
            <img onClick={() => nav("/")} src="JamPad.png" alt="logo" style={{width: 70, height: 70}}/>
            <Typography
              onClick={() => nav("/")}
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2, display: { xs: 'flex', md: 'none' },
                flexGrow: 3,
                fontFamily: 'monospace', fontSize: '30px', fontWeight: 700,
                color: 'inherit',
                textDecoration: 'none',
                cursor: 'pointer'
              }}
            >
              JamPad
            </Typography>
          </Typography>



          {/* LARGE SCREEN WIDTH */} 
          <Typography 
            onClick={() => nav("/")}
            noWrap
            component="div"
            sx={{mr: 2, display: {xs: "none", md: "flex"}}}
          >
            <img src="JamPad.png" alt='logo' style={{ width: 70, height: 70, cursor: 'pointer' }}/>
          </Typography>
          <Typography
            onClick={() => nav("/")}
            variant="h6"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace', fontWeight: 700, fontSize: '30px',
              color: 'inherit',
              textDecoration: 'none',
              cursor: 'pointer'
            }}
          >JamPad</Typography> 
          <Box sx={{ ml: 2, flexGrow: 8, gap: '28px', 
            display: { xs: 'none', md: 'flex' }
          }}>
            <Button  onClick={() => nav("/")} sx={{ my: 1, color: 'white', display: 'block', }}>Event Map</Button>
            <Button  onClick={() => nav("/search")} sx={{ my: 1, color: 'white', display: 'block', }}>Search</Button>
            <Button  onClick={() => nav("/feed")} sx={{ my: 1, color: 'white', display: 'block', }}>Event Feed</Button>
            <Button  onClick={() => nav("/create_event")} sx={{ my: 1, color: 'white', display: 'block', }}>Create Event</Button>
          </Box>

          <Box sx={{ flexGrow: 0, alignSelf: 'center' }}>
            <Tooltip title="Account" onClick={handleOpenUserMenu} >
              <Avatar src={profile?.pfp ?? ''} style={{ 
                width: '56px', height: '56px', border: '2px solid lightblue'
              }}/>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={() =>  {
                setAnchorElUser(false);
                nav("/profile");
              }}>
                <Typography sx={{ textAlign: 'center' }}>My Profile</Typography>
              </MenuItem>
              <MenuItem onClick={() =>  {
                setAnchorElUser(false);
                nav("/settings");
              }}>
                <Typography sx={{ textAlign: 'center' }}>Settings</Typography>
              </MenuItem>

              { profile ? 
                <MenuItem onClick={() =>  {
                  if(window.confirm("Sign out?")) {
                    setAnchorElUser(false);
                    logout();
                  }
                }}>
                  <Typography sx={{ textAlign: 'center' }}>Sign out</Typography>
                </MenuItem>
              :
                <MenuItem onClick={() =>  {
                  setAnchorElUser(false);
                  window.location.reload();
                }}>
                  <Typography sx={{ textAlign: 'center' }}>Sign in</Typography>
                </MenuItem>
              }
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>);
}
export default ResponsiveAppBar;